(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/helpers/blocking-info-helper.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/helpers/blocking-info-helper.js');

'use strict';

const getLastSuspension = svs.accountservicesReact.deposit.helpers.suspensionHelper.getLastSuspension;
const _svs$accountservicesR = svs.accountservicesReact.deposit.services.depositService,
  getSuspensions = _svs$accountservicesR.getSuspensions,
  getCurrentStatus = _svs$accountservicesR.getCurrentStatus,
  getNetLossRestrictions = _svs$accountservicesR.getNetLossRestrictions,
  getDepositRestrictions = _svs$accountservicesR.getDepositRestrictions,
  getDayTimeLimit = _svs$accountservicesR.getDayTimeLimit;
const amountLimits = svs.accountservicesReact.deposit.constants.amountLimits;

const getBlockingInfo = async maxLimitRemaining => {

  if (svs.core.userSession.isBlocked()) {
    return {
      isBlockedNAR: true
    };
  }

  const currentStatus = await getCurrentStatus();
  if (currentStatus !== null && currentStatus !== void 0 && currentStatus.currentStatus.includes('DEPOSITS_SUSPENDED')) {
    const _await$getNetLossRest = await getNetLossRestrictions(),
      amountLimit = _await$getNetLossRest.amountLimit,
      endTime = _await$getNetLossRest.endTime;
    const netLossRestrictions = {
      amountLimit,
      endTime
    };
    if (netLossRestrictions !== null && netLossRestrictions !== void 0 && netLossRestrictions.amountLimit) {
      return {
        netLossRestrictions
      };
    }

    const _await$getDepositRest = await getDepositRestrictions(),
      showFirstDialog = _await$getDepositRest.showFirstDialog,
      showSecondDialog = _await$getDepositRest.showSecondDialog,
      depositsMade = _await$getDepositRest.depositsMade;
    const depositRestrictions = {
      showFirstDialog,
      showSecondDialog,
      depositsMade
    };
    if (depositRestrictions.showFirstDialog || depositRestrictions.showSecondDialog) {
      return {
        depositRestrictions
      };
    }

    return {
      ttRestriction: true
    };
  }

  const suspensionsResponse = await getSuspensions();
  if (suspensionsResponse) {
    const lastSuspension = getLastSuspension(suspensionsResponse);
    if (lastSuspension) {
      return {
        suspensions: lastSuspension
      };
    }
  }

  const dayTimeLimit = await getDayTimeLimit();
  if (dayTimeLimit !== null && dayTimeLimit !== void 0 && dayTimeLimit.dayTimeExpired) {
    return {
      dayTimeLimit
    };
  }

  if (maxLimitRemaining < amountLimits.MIN) {
    return {
      maxLimitRemaining
    };
  }

  return false;
};
svs.accountservicesReact.deposit.helpers.blockingInfoHelper = {
  getBlockingInfo
};

 })(window);